import { Tooltip } from '@progress/kendo-react-tooltip'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import React from 'react'
import * as Flash from '../../../flash'
import * as Constants from '../../constants'
import { IntegrationConfigRenderBase } from './integrationConfigRenderBase'

declare const RASA_SELF_SERVICE_API: string

const RASA_FIELDS = {
  IS_SUBSCRIBED: 'is_subscribed'
}

const RICH_INTEGRATION_FIELDS = {
  LAST_CLICK: 'last_click',
  LAST_ARTICLE_CLICK: 'last_article_click',
  LAST_OPEN: 'last_open',
  ANALYTICS_TOPICS: 'topics',
  CATEGORIES: 'categories',
  UNIQUE_CLICKS: 'unique_clicks',
  UNIQUE_OPENS: 'unique_opens',
  UNIQUE_TAGS: 'unique_tags',
  LAST_DELIVER: 'last_deliver',
  DELIVER_STATUS: 'deliver_status',
  ENGAGEMENT: 'engagement',
  ENGAGEMENT_UPDATE: 'engagement_update',
  SUBSCRIPTION_STATUS: 'subscription_status',
  SUBSCRIPTION_CHANGED: 'subscription_changed'
}

export class NoviAMSConfigRender extends IntegrationConfigRenderBase {
  protected supportsFilter: boolean = true
  protected showContactsCount = false
  private apiEndpointName: string = 'api_endpoint'
  private systemApiKeyName: string = 'systemApiKey'
  private subscribedFieldIdName: string = 'subscribedFieldId'
  
  // Rich integration field names
  private lastClickFieldName: string = 'lastClickField'
  private lastArticleClickFieldName: string = 'lastArticleClickField'
  private lastOpenFieldName: string = 'lastOpenField'
  private topicsFieldName: string = 'topicsField'
  private categoriesFieldName: string = 'categoriesField'
  private uniqueClicksFieldName: string = 'uniqueClicksField'
  private uniqueOpensFieldName: string = 'uniqueOpensField'
  private uniqueTagsFieldName: string = 'uniqueTagsField'
  private lastDeliverFieldName: string = 'lastDeliverField'
  private deliverStatusFieldName: string = 'deliverStatusField'
  private engagementFieldName: string = 'engagementField'
  private engagementUpdateFieldName: string = 'engagementUpdateField'
  private subscriptionStatusFieldName: string = 'subscriptionStatusField'
  private subscriptionChangedFieldName: string = 'subscriptionChangedField'
  
  constructor(props: any) {
    super(props)
    this.state = {
      ...this.state,
      customFields: [],
      isLoadingCustomFields: false,
    }
  }

  protected initializeCustomProps() {
    if (this.systemApiAttribute && this.systemApiAttribute.api_endpoint) {
      this.props.propertiesChanged({
        [this.apiEndpointName]: this.systemApiAttribute.api_endpoint,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.api_key) {
      this.props.propertiesChanged({
        [this.systemApiKeyName]: this.systemApiAttribute.api_key,
      })
    }
    
    // Initialize custom field mappings from system attributes
    if (this.systemApiAttribute && this.systemApiAttribute.custom_field_mappings && Array.isArray(this.systemApiAttribute.custom_field_mappings)) {
      this.systemApiAttribute.custom_field_mappings.forEach((mapping: any) => {
        // Standard subscription field (only is_subscribed for normal integration)
        if (mapping.rasa_field === RASA_FIELDS.IS_SUBSCRIBED) {
          this.props.propertiesChanged({
            [this.subscribedFieldIdName]: mapping.id,
          })
        }
        // Rich integration fields
        else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.LAST_CLICK) {
          this.props.propertiesChanged({[this.lastClickFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.LAST_ARTICLE_CLICK) {
          this.props.propertiesChanged({[this.lastArticleClickFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.LAST_OPEN) {
          this.props.propertiesChanged({[this.lastOpenFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.ANALYTICS_TOPICS) {
          this.props.propertiesChanged({[this.topicsFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.CATEGORIES) {
          this.props.propertiesChanged({[this.categoriesFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.UNIQUE_CLICKS) {
          this.props.propertiesChanged({[this.uniqueClicksFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.UNIQUE_OPENS) {
          this.props.propertiesChanged({[this.uniqueOpensFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.UNIQUE_TAGS) {
          this.props.propertiesChanged({[this.uniqueTagsFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.LAST_DELIVER) {
          this.props.propertiesChanged({[this.lastDeliverFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.DELIVER_STATUS) {
          this.props.propertiesChanged({[this.deliverStatusFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.ENGAGEMENT) {
          this.props.propertiesChanged({[this.engagementFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.ENGAGEMENT_UPDATE) {
          this.props.propertiesChanged({[this.engagementUpdateFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.SUBSCRIPTION_STATUS) {
          this.props.propertiesChanged({[this.subscriptionStatusFieldName]: mapping.id})
        } else if (mapping.rasa_field === RICH_INTEGRATION_FIELDS.SUBSCRIPTION_CHANGED) {
          this.props.propertiesChanged({[this.subscriptionChangedFieldName]: mapping.id})
        }
      })
    }
  }

  protected isAuthenticateButtonEnabled(): boolean {
    return !this.state.isConnecting && !!this.props.data.api_endpoint && !!this.props.data.systemApiKey
  }

  protected connect() {
    if (this.props.data.is_active && this.isRichIntegration() && !this.isRichIntegrationChecked()) {
      return this.richIntegrationCheckBoxChange(true)
    }
    
    const url = this.buildPopUpUrl()
    this.setState({
      isConnecting: true,
    })
    AjaxWrapper.ajax(url, HttpMethod.GET, {})
    .then((result) => {
      if (!!result.success) {
        let redirectUrl = Constants.INTEGRATIONS_CONFIG_URL + '?id=' + result.payload.communitySystemId + '&operation=' + `${result.operation}${Constants.SUCCESS}`
        if (this.isRichIntegration()) {
          redirectUrl += '&isRichIntegration=true'
        }
        window.location.href = redirectUrl
      } else {
        this.setState({
          isConnecting: false,
        })
        const errMsg = result.payload ? result.payload.message : ''
        this.props.context.store.dispatch(Flash.showFlashError(errMsg))
      }
    }).catch((err) => {
      this.setState({
        isConnecting: false,
      })
      let message = ''
      try {
        message = err.response.message
      } catch (e) {
        message = err.message
      }
      this.props.context.store.dispatch(Flash.showFlashError(message))
    })
  }

  protected buildPopUpUrl(): string {
    let decodedState = this.communityId
    if (this.isRichIntegration()) {
      decodedState += `|rich_integration`
    }
    const encodedState = btoa(decodedState)
    
    let url = `${RASA_SELF_SERVICE_API}/integrations/${this.props.data.systemName.replace(' ', '').toLowerCase()}-api-callback?state=${encodedState}&api_endpoint=${this.props.data.api_endpoint}&api_key=${this.props.data.systemApiKey}`
    
    // Add custom field mappings if any fields are selected
    const customFieldMappings = []
    
    // Standard subscription field (only is_subscribed for normal integration)
    if (this.props.data[this.subscribedFieldIdName]) {
      customFieldMappings.push({
        id: this.props.data[this.subscribedFieldIdName], 
        name: 'subscribed_field_id',
        rasa_field: RASA_FIELDS.IS_SUBSCRIBED
      })
    }
    
    // Rich integration fields
    const richIntegrationMappings = [
      {fieldName: this.lastClickFieldName, rasaField: RICH_INTEGRATION_FIELDS.LAST_CLICK, name: 'last_click_field'},
      {fieldName: this.lastArticleClickFieldName, rasaField: RICH_INTEGRATION_FIELDS.LAST_ARTICLE_CLICK, name: 'last_article_click_field'},
      {fieldName: this.lastOpenFieldName, rasaField: RICH_INTEGRATION_FIELDS.LAST_OPEN, name: 'last_open_field'},
      {fieldName: this.topicsFieldName, rasaField: RICH_INTEGRATION_FIELDS.ANALYTICS_TOPICS, name: 'topics_field'},
      {fieldName: this.categoriesFieldName, rasaField: RICH_INTEGRATION_FIELDS.CATEGORIES, name: 'categories_field'},
      {fieldName: this.uniqueClicksFieldName, rasaField: RICH_INTEGRATION_FIELDS.UNIQUE_CLICKS, name: 'unique_clicks_field'},
      {fieldName: this.uniqueOpensFieldName, rasaField: RICH_INTEGRATION_FIELDS.UNIQUE_OPENS, name: 'unique_opens_field'},
      {fieldName: this.uniqueTagsFieldName, rasaField: RICH_INTEGRATION_FIELDS.UNIQUE_TAGS, name: 'unique_tags_field'},
      {fieldName: this.lastDeliverFieldName, rasaField: RICH_INTEGRATION_FIELDS.LAST_DELIVER, name: 'last_deliver_field'},
      {fieldName: this.deliverStatusFieldName, rasaField: RICH_INTEGRATION_FIELDS.DELIVER_STATUS, name: 'deliver_status_field'},
      {fieldName: this.engagementFieldName, rasaField: RICH_INTEGRATION_FIELDS.ENGAGEMENT, name: 'engagement_field'},
      {fieldName: this.engagementUpdateFieldName, rasaField: RICH_INTEGRATION_FIELDS.ENGAGEMENT_UPDATE, name: 'engagement_update_field'},
      {fieldName: this.subscriptionStatusFieldName, rasaField: RICH_INTEGRATION_FIELDS.SUBSCRIPTION_STATUS, name: 'subscription_status_field'},
      {fieldName: this.subscriptionChangedFieldName, rasaField: RICH_INTEGRATION_FIELDS.SUBSCRIPTION_CHANGED, name: 'subscription_changed_field'}
    ]

    richIntegrationMappings.forEach(mapping => {
      if (this.props.data[mapping.fieldName]) {
        customFieldMappings.push({
          id: this.props.data[mapping.fieldName],
          name: mapping.name,
          rasa_field: mapping.rasaField
        })
      }
    })
    
    if (customFieldMappings.length > 0) {
      url += `&custom_field_mappings=${encodeURIComponent(JSON.stringify(customFieldMappings))}`
    }
    
    return url
  }

  protected renderCustomBox() {
    return <div className="api-key-wrapper">
      <div>
        {this.createTextBox('API Endpoint', this.apiEndpointName, 'The base URL of your Novi AMS API endpoint (e.g., https://yoursite.novi-ams.com)')}
      </div>
      <div>
        {this.createTextBox('API Key', this.systemApiKeyName, 'Your Novi AMS API key for authentication')}
      </div>
    </div>
  }

  protected renderFilter() {
    if (this.supportsFilter && this.state.filters) {
      return <div className="filter-wrapper">
        <div className="filter-name-wrapper">
          <div>
            <div className="field-label-credentials">
              Group Selection and Custom Field Mapping
            </div>
            <div className="filter-name-box">
              <div className="filter-name-text">
                <div className="filters-dropdown">
                  <div style={{marginBottom: '20px'}}>
                    <h4>Group Selection</h4>
                    <p>Select the group you want to sync contacts from:</p>
                    {this.renderFilterDropdown()}
                  </div>
                  <div>
                    <h4>Subscription Field Mapping</h4>
                    <p>Select the custom field for subscription tracking:</p>
                    <div>
                      {this.createCustomFieldDropdown('Subscribed Field ID', this.subscribedFieldIdName, 'Select the custom field that tracks subscription status')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }

  protected getRichIntegration() {
    return this.isRichIntegration() && (this.state.authenticated || this.props.data.is_active) ?
      <div className="outbound-confirm-checkbox-wrapper">
        <div className="outbound-confirm-checkbox-line1 noviams-custom-field">
          <p className="outbound-confirm-checkbox-text rich-checkbox-label">
            Push engagement data to Novi AMS
          </p>
          <input type="checkbox" className="outbound-confirm-checkbox"
            checked={this.isRichIntegrationChecked()}
            onChange={(e) => this.richIntegrationCheckBoxChange(e.target.checked)}
          />
        </div>
        {this.isRichIntegrationChecked() && this.renderRichIntegrationFields()}
        {this.renderIntegrationTips()}
      </div> : <div>{this.renderIntegrationTips()}</div>
  }

  protected renderIntegrationTips() {
    return null
  }

  private renderRichIntegrationFields() {
    const richFields = [
      {fieldName: this.lastClickFieldName, displayName: 'Last Click Field', helpText: 'Field to store the last click timestamp'},
      {fieldName: this.lastArticleClickFieldName, displayName: 'Last Article Click Field', helpText: 'Field to store the last article click timestamp'},
      {fieldName: this.lastOpenFieldName, displayName: 'Last Open Field', helpText: 'Field to store the last email open timestamp'},
      {fieldName: this.topicsFieldName, displayName: 'Topics Field', helpText: 'Field to store analytics topics data'},
      {fieldName: this.categoriesFieldName, displayName: 'Categories Field', helpText: 'Field to store article categories'},
      {fieldName: this.uniqueClicksFieldName, displayName: 'Unique Clicks Field', helpText: 'Field to store unique clicks count'},
      {fieldName: this.uniqueOpensFieldName, displayName: 'Unique Opens Field', helpText: 'Field to store unique opens count'},
      {fieldName: this.uniqueTagsFieldName, displayName: 'Unique Tags Field', helpText: 'Field to store unique tags data'},
      {fieldName: this.lastDeliverFieldName, displayName: 'Last Deliver Field', helpText: 'Field to store the last delivery timestamp'},
      {fieldName: this.deliverStatusFieldName, displayName: 'Deliver Status Field', helpText: 'Field to store delivery status'},
      {fieldName: this.engagementFieldName, displayName: 'Engagement Field', helpText: 'Field to store engagement metrics'},
      {fieldName: this.engagementUpdateFieldName, displayName: 'Engagement Update Field', helpText: 'Field to store engagement update timestamp'},
      {fieldName: this.subscriptionStatusFieldName, displayName: 'Subscription Status Field', helpText: 'Field to store subscription status'},
      {fieldName: this.subscriptionChangedFieldName, displayName: 'Subscription Changed Field', helpText: 'Field to store subscription change timestamp'}
    ]

    return (
      <div style={{marginTop: '20px'}}>
        <h4>Rich Integration Field Mappings</h4>
        <p>Select Novi AMS custom fields to store engagement data:</p>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '15px'}}>
          {richFields.map((field, index) => (
            <div key={index}>
              {this.createCustomFieldDropdown(field.displayName, field.fieldName, field.helpText)}
            </div>
          ))}
        </div>
      </div>
    )
  }

  protected renderTwoWayStatus() {
    if (this.validateTwoWayStatus()) {
      return <div className="outbound-confirm-checkbox-wrapper">
        {this.getRichIntegration()}
        {/* Don't show the regular two-way checkbox for rich integrations */}
        {!this.isRichIntegration() && (
          <div className="outbound-confirm-checkbox-line1">
            <p className="outbound-confirm-checkbox-text">
              Push rasa.io subscription and unsubscribe status to {this.props.data.systemName}
            </p>
            <input type="checkbox" className="outbound-confirm-checkbox"
              checked={this.isTwoWayChecked()}
              onChange={(e) => this.onTwoWayCheckboxChange(e.target.checked)}
            />
          </div>
        )}
      </div>
    }
  }

  protected shouldRenderDisconnect(): boolean {
    return super.shouldRenderDisconnect() && (!this.isRichIntegration() || this.isRichIntegrationChecked())
  }

  protected richIntegrationCheckBoxChange(isRichSync: boolean) {
    // Implementation for handling rich integration checkbox changes
    // This should update the integration settings to enable/disable rich integration
    const currentAttributes = this.systemApiAttribute || {}
    const updatedAttributes = {
      ...currentAttributes,
      is_full_integration: isRichSync
    }
    
    this.props.propertiesChanged({
      system_api_attribute: JSON.stringify(updatedAttributes)
    })
    
    if (this.props.data.is_active && this.props.saveRecord) {
      this.props.saveRecord(this.props.data.id)
        .then(() => {
          // Success handling can be added here if needed
        })
        .catch((error) => {
          this.props.context.store.dispatch(Flash.showFlashError('Failed to update rich integration settings'))
        })
    }
  }

  private createTextBox(displayName: string, fieldName: string, helpText: string = '') {
    return <div>
      <Tooltip openDelay={100} position="top" anchorElement="pointer" className="rasa-grid-tooltip">
        <div className="field-label-credentials">
          <span title={helpText || `Input your ${displayName}`}>
            {displayName} (Required)
          </span>
        </div>
      </Tooltip>
      <div className="input-wrapper">
        {!this.props.data.is_active
        ? <input className={`field-textbox field-textbox-${fieldName} system-api-key`}
            value={(this.props.data[fieldName] || '')}
            onChange={(e) => this.props.propertiesChanged({[fieldName]: e.target.value})}
            placeholder={`Enter your ${displayName}`}
          />
        : <div className={`field-textbox field-textbox-${fieldName} system-api-key`}>
            {(this.props.data[fieldName] || '')}
          </div>
        }
      </div>
    </div>
  }

  private createCustomFieldDropdown(displayName: string, fieldName: string, helpText: string = '') {
    const options = this.getCustomFieldOptions()
    const isLoading = this.state.isLoadingCustomFields
    
    // Map field names to rasa fields
    const getRasaFieldName = (name: string) => {
      switch (name) {
        // Standard subscription field (only is_subscribed for normal integration)
        case this.subscribedFieldIdName:
          return RASA_FIELDS.IS_SUBSCRIBED
        // Rich integration fields
        case this.lastClickFieldName:
          return RICH_INTEGRATION_FIELDS.LAST_CLICK
        case this.lastArticleClickFieldName:
          return RICH_INTEGRATION_FIELDS.LAST_ARTICLE_CLICK
        case this.lastOpenFieldName:
          return RICH_INTEGRATION_FIELDS.LAST_OPEN
        case this.topicsFieldName:
          return RICH_INTEGRATION_FIELDS.ANALYTICS_TOPICS
        case this.categoriesFieldName:
          return RICH_INTEGRATION_FIELDS.CATEGORIES
        case this.uniqueClicksFieldName:
          return RICH_INTEGRATION_FIELDS.UNIQUE_CLICKS
        case this.uniqueOpensFieldName:
          return RICH_INTEGRATION_FIELDS.UNIQUE_OPENS
        case this.uniqueTagsFieldName:
          return RICH_INTEGRATION_FIELDS.UNIQUE_TAGS
        case this.lastDeliverFieldName:
          return RICH_INTEGRATION_FIELDS.LAST_DELIVER
        case this.deliverStatusFieldName:
          return RICH_INTEGRATION_FIELDS.DELIVER_STATUS
        case this.engagementFieldName:
          return RICH_INTEGRATION_FIELDS.ENGAGEMENT
        case this.engagementUpdateFieldName:
          return RICH_INTEGRATION_FIELDS.ENGAGEMENT_UPDATE
        case this.subscriptionStatusFieldName:
          return RICH_INTEGRATION_FIELDS.SUBSCRIPTION_STATUS
        case this.subscriptionChangedFieldName:
          return RICH_INTEGRATION_FIELDS.SUBSCRIPTION_CHANGED
        default:
          return fieldName
      }
    }
    
    const handleFieldChange = (selectedValue: string) => {
      const rasaFieldName = getRasaFieldName(fieldName)
      
      // Update the field value for display
      this.props.propertiesChanged({[fieldName]: selectedValue})
      
      // Get current system_api_attribute
      const currentAttributes = this.systemApiAttribute || {}
      const currentCustomFields = currentAttributes.custom_field_mappings || []
      
      if (!selectedValue) {
        // Remove field mapping if no value selected
        const filteredMappings = currentCustomFields.filter((field: any) => field.rasa_field !== rasaFieldName)
        const updatedAttrs = {
          ...currentAttributes,
          custom_field_mappings: filteredMappings
        }
        this.props.propertiesChanged({
          system_api_attribute: JSON.stringify(updatedAttrs)
        })
        this.systemApiAttribute = updatedAttrs
        return
      }
      
      // Find the selected field info
      const selectedField = options.find(option => option.value === selectedValue)
      if (!selectedField) return
      
      // Remove existing mapping for this rasa field
      const existingFieldsFiltered = currentCustomFields.filter((field: any) => field.rasa_field !== rasaFieldName)
      
      // Add new mapping
      const newFieldMapping = {
        rasa_field: rasaFieldName,
        id: selectedField.value,
        name: selectedField.name
      }
      
      const updatedCustomFields = [...existingFieldsFiltered, newFieldMapping]
      
      // Update system_api_attribute with custom_field_mappings
      const finalAttributes = {
        ...currentAttributes,
        custom_field_mappings: updatedCustomFields
      }
      
      this.props.propertiesChanged({
        system_api_attribute: JSON.stringify(finalAttributes)
      })
      this.systemApiAttribute = finalAttributes
    }
    
    // Determine if field is required (only is_subscribed field is required for normal integration)
    const isRequired = fieldName === this.subscribedFieldIdName
    
    return <div>
      <Tooltip openDelay={100} position="top" anchorElement="pointer" className="rasa-grid-tooltip">
        <div className="field-label-credentials">
          <span title={helpText}>
            {displayName} {isRequired ? '(Required)' : '(Optional)'}
            {isLoading && <span style={{marginLeft: '8px', fontSize: '12px', color: '#666'}}>Loading...</span>}
          </span>
        </div>
      </Tooltip>
      <div className="input-wrapper">
        {!this.props.data.is_active
        ? <select className={`field-textbox field-textbox-${fieldName} system-api-key`}
            value={(this.props.data[fieldName] || '')}
            onChange={(e) => handleFieldChange(e.target.value)}
            disabled={isLoading}
          >
            <option value="">{isLoading ? 'Loading custom fields...' : 'Select Custom Field'}</option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.name}
              </option>
            ))}
          </select>
        : <div className={`field-textbox field-textbox-${fieldName} system-api-key`}>
            {(() => {
              const fieldId = this.props.data[fieldName] || ''
              if (!fieldId) return ''
              
              // Find the field name from the options
              const selectedField = options.find(option => option.value === fieldId)
              return selectedField ? selectedField.name : fieldId
            })()}
          </div>
        }
        {!isLoading && options.length === 0 && this.props.data.api_endpoint && this.props.data.systemApiKey && (
          <div style={{fontSize: '12px', color: '#e74c3c', marginTop: '4px'}}>
            No custom fields found. Please verify your connection settings.
          </div>
        )}
        {!this.props.data.api_endpoint || !this.props.data.systemApiKey ? (
          <div style={{fontSize: '12px', color: '#f39c12', marginTop: '4px'}}>
            Enter API endpoint and API key to load custom fields
          </div>
        ) : null}
      </div>
    </div>
  }

  private getCustomFieldOptions() {
    return this.state.customFields || []
  }

  private loadCustomFields = () => {
    if (!this.props.data.api_endpoint || !this.props.data.systemApiKey) {
      return
    }

    this.setState({ isLoadingCustomFields: true })

    const url = `${RASA_SELF_SERVICE_API}/integrations/${this.props.data.community_identifier}/custom-fields/${this.props.data.community_system_id}`
    
    AjaxWrapper.ajax(url, HttpMethod.GET, {})
      .then((result) => {
        if (result && Array.isArray(result)) {
          this.setState({
            customFields: result.map((field: any) => ({
              name: field.name,
              type: field.type || 'string',
              value: field.value
            })),
            isLoadingCustomFields: false,
          })
        } else {
          this.setState({
            customFields: [],
            isLoadingCustomFields: false,
          })
        }
      })
      .catch((error) => {
        this.setState({
          customFields: [],
          isLoadingCustomFields: false,
        })
        this.props.context.store.dispatch(Flash.showFlashError('Failed to load custom fields. Please verify your connection settings.'))
      })
  }

  componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount()
    }
    // Load custom fields only when the integration is authenticated (is_active)
    if (this.props.data.is_active && this.props.data.community_system_id) {
      this.loadCustomFields()
    }
  }

  componentDidUpdate(prevProps: any) {
    // Load custom fields when integration becomes active
    const hasBeenActivated = !prevProps.data.is_active && this.props.data.is_active
    
    if (hasBeenActivated && this.props.data.community_system_id) {
      this.loadCustomFields()
    }
  }
}